import { RouteThunk } from "redux-first-router";
import { ResourceTypeLink } from "@evergis/api";

import { redirectToCatalog } from "../ducks/location/location";
import { setProjectName } from "../ducks/project/project";
import { getLocation, getLocationPayload, getLocationQuery } from "../ducks/location/selectors";
import { getUser } from "../ducks/user";
import { getAppConfigShared } from "../ducks/appConfig";
import { RootState } from "../ducks/reducers";
import { RouteName } from "../appConfig/types";

export const currentProjectThunk: RouteThunk<RootState> = async (dispatch, getState) => {
  const state = getState();
  const payload = getLocationPayload(state);
  const { type, prev } = getLocation(state);
  const { project: projectFromQuery, sharedMap } = getLocationQuery(state);
  const shared = getAppConfigShared(state);
  const user = getUser(state);
  const project = shared ? sharedMap : projectFromQuery || payload?.project;

  if (
    prev?.type === type &&
    !state.project.loading &&
    ((payload?.project && prev?.payload?.project === payload?.project) ||
      (payload?.sharedMap && prev?.payload?.sharedMap === payload?.sharedMap))
  ) {
    return;
  }

  if (!project && user && type !== RouteName.Catalog) {
    return dispatch(redirectToCatalog({ tab: ResourceTypeLink.Project }));
  }

  if (!project) {
    return;
  }

  return dispatch(setProjectName(project));
};

export default currentProjectThunk;
